'use client';
import ArrowIcon from '@/images/icon/arrow-default.svg';
import { useState, forwardRef } from 'react';
import styled from 'styled-components';
import CDNImage from '../../cdnImage/cdnImage';
import styles from './index.module.scss';
import UKDrawer from '@/components/UKDrawer';

// const DialogContentWrapper = styled.div`
//   .dialog-content {
//     font-size: 14px;
//     margin-bottom: 32px;
//   }
//   .dialog-btn-wrapper {
//     display: flex;
//     justify-content: flex-end;
//     gap: 4px;
//     .confirm {
//       width: 80px;
//       line-height: 32px;
//       background: var(--sys-color-Primary700);
//       text-align: center;
//       font-size: 14px;
//       color: #fff;
//       border-radius: 4px;
//       cursor: pointer;
//     }
//   }
// `;
// const AgeVerificationDialog = ({ isOpen, onClose, data }: any) => {
//   const { title, content } = data || {};
//   return (
//     <UKDialog
//       open={isOpen}
//       onClose={onClose}
//       showCloseBtn={true}
//       sx={{
//         '& .MuiDialog-paper': {
//           width: '520px',
//           margin: '0',
//           borderRadius: '12px',
//         },
//         '& .MuiDialogTitle-root': {
//           fontSize: '16px',
//           fontWeight: 'bold',
//           lineHeight: '20px',
//           padding: '20px 24px 12px 24px',
//         },
//       }}
//     >
//       <DialogTitle>{title}</DialogTitle>
//       <DialogContent sx={{}}>
//         <DialogContentWrapper>
//           <div className='dialog-content' dangerouslySetInnerHTML={{ __html: content }}></div>
//           <div className='dialog-btn-wrapper'>
//             <div className='confirm' onClick={onClose}>
//               OK
//             </div>
//           </div>
//         </DialogContentWrapper>
//       </DialogContent>
//     </UKDialog>
//   );
// };

const AgeVerification = forwardRef<HTMLDivElement, { data: any }>(({ data }, ref) => {
  const [open, setOpen] = useState<boolean>(false);
  const { title, icon, shortText, detailText } = data || {};
  if (!title) {
    return null;
  }
  return (
    <div ref={ref} className={styles.ageVerificationWrapper}>
      <header onClick={() => setOpen(true)}>
        <CDNImage src={icon} width={30} height={30} alt='icon' />
        {title}
        <ArrowIcon className={styles.arrowRight} />
      </header>
      <section className={styles.verTextContent}>{shortText}</section>
      {/* <AgeVerificationDialog
        isOpen={open}
        onClose={() => setOpen(false)}
        data={{
          title,
          content: detailText,
        }}
      /> */}
      <UKDrawer
        width={430}
        title={title}
        openDrawer={open || false}
        handleClose={() => setOpen(false)}
      >
        <div
          className={styles.verDrawContent}
          dangerouslySetInnerHTML={{ __html: detailText }}
        ></div>
      </UKDrawer>
    </div>
  );
});

AgeVerification.displayName = 'AgeVerification';

export default AgeVerification;
